export default "__VITE_ASSET__DsSI5Max__"